module.exports = __webpack_public_path__ + "img/diy.0debe455.png";